<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="apol"><a id="page_xxi"></a><strong>Apologia Pro !%@&amp; Sua</strong></h2>
<p class="noindent">I beg forgiveness from the reader for the vulgar language in this book. Politics is a vulgar fucking subject. I have resorted to barnyard words because of the amount of bullshit, horseshit, and chickenshit involved in politics. I’m sorry I can’t devise a more polite mode of expression. I can only blame myself. It is possible, I suppose, to take a decorous approach to politics. But I’m reminded of the American guest at a dinner in one of the great houses of Britain. The American was seated to the left of a very grand and fat old duchess and an Englishman was seated on her right. During the soup course the duchess farted. The Englishman, taking chivalrous responsibility, said, “I beg your pardon.” During the fish course the duchess farted again, louder than before. Once more, the Englishman said, “I beg your pardon.” Then, during the meat course, the duchess cut loose with a tremendous, resounding blast. The Englishman said, “I beg—”</p>
<p class="indent">“No, no,” the American interrupted. “This one’s on me.”<a id="page_xxii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// apol.vue?afd69586